import { render } from "./NtutuCare.vue?vue&type=template&id=19a75fa0&scoped=true"
import script from "./NtutuCare.vue?vue&type=script&lang=js"
export * from "./NtutuCare.vue?vue&type=script&lang=js"

import "./NtutuCare.vue?vue&type=style&index=0&id=19a75fa0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a75fa0"]])

export default __exports__